export const getOrderCategories = (order: {
    order_categories?: unknown;
    customer_category?: unknown;
}): string[] => {
    if (Array.isArray(order.order_categories)) {
        return order.order_categories.filter(
            (category): category is string =>
                typeof category === "string" && category.length > 0,
        );
    }

    if (typeof order.customer_category === "string") {
        return order.customer_category.split(";").filter(Boolean);
    }

    return [];
};
